import { apiUrl } from './api';

export type StarsInvoiceStatus = 'paid' | 'cancelled' | 'failed' | 'pending';

export function openTelegramStarsInvoice(invoiceUrl: string): Promise<StarsInvoiceStatus> {
  // @ts-ignore
  const tg = window.Telegram?.WebApp;
  if (!tg || typeof tg.openInvoice !== 'function') {
    return Promise.reject(new Error('Оплата Stars доступна в Telegram Mini App'));
  }
  return new Promise((resolve) => {
    try {
      tg.openInvoice(invoiceUrl, (status: string) => {
        resolve((status as StarsInvoiceStatus) || 'failed');
      });
    } catch (e) {
      resolve('failed');
    }
  });
}

/**
 * Цифровой товар: счёт Stars → openInvoice. USDT-баланс не списывается.
 */
export async function payDigitalGoodWithStars(
  token: string,
  sku: string
): Promise<StarsInvoiceStatus> {
  const r = await fetch(apiUrl('/api/payments/stars-invoice'), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ sku })
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(String(d.error || `Не удалось создать счёт (${r.status})`));
  }
  const url = String(d.invoice_url || '');
  if (!url) {
    throw new Error('Сервер не вернул ссылку на оплату Stars');
  }
  return openTelegramStarsInvoice(url);
}
